export const CLASSIC_TEMPLATE = 'classic';
export const CREATE_YOUR_OWN_TEMPLATE = 'create-your-own';
